<template>
  <div v-if="!isEmpty(dispatch)">
    <v-layout column>
      <v-toolbar>
        <v-layout align-center>
          <v-layout>
            <v-btn icon @click="">
              <v-icon
                color="grey darken-2"
                @click="$router.push(`/configuracao/despachos/lista`)"
              >mdi-arrow-left
              </v-icon>
            </v-btn>
            <v-layout
              row
              class="mx-4"
              align-center
            >
              <v-layout column>
                <v-tooltip
                  bottom
                  class="text-truncate"
                  max-width="800">
                  <span slot="activator">{{ administrativeUnitsInDispatch()}}</span>
                  {{ administrativeUnitsInDispatch() }}
                </v-tooltip>
                <span class="body-1 grey--text text--darken-2">{{ dispatch.title || 'Sem Nome' }}</span>
              </v-layout>

              <edit-attributes-dispatch-dialog
                :dispatch="Object.assign({}, dispatch)"
                :administrativeUnitsAvailable="administrativeUnitsAvailable"
                @save="onSaveEditButton($event)"
              />

              <save-dispatch-dialog
                :dispatch="dispatch"/>

            </v-layout>
          </v-layout>

        </v-layout>
      </v-toolbar>
    </v-layout>

    <v-layout class="pt-">
      <editor :init="editorOptions"
              id="1"
              v-model="dispatch.text"
              :value="dispatch.text"
              @input="html = $event"></editor>
    </v-layout>

  </div>

</template>

<script>
  import DispatchService from '@/services/system/DispatchService';
  import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';

  import EditAttributesDispatchDialog from "@/components/settings/dispatches/EditAttributesDispatchDialog";
  import SaveDispatchDialog from "@/components/settings/dispatches/SaveDispatchDialog";

  import {map, join, isEmpty} from 'lodash';

  import Editor from '@tinymce/tinymce-vue';
  import TINYMCE_OPTIONS from '@/constants/TINYMCE_OPTIONS';

  export default {
    name: 'DispatchForm',
    components: {
      EditAttributesDispatchDialog,
      SaveDispatchDialog,
      Editor
    },
    async mounted() {
      AdministrativeUnitService
        .all({all: true})
        .then((res) => {
          this.administrativeUnitsAvailable = res.data;
        });

      if (this.$route.params.id !== undefined) {
        const response = await DispatchService.show(this.$route.params.id)

        this.dispatch.id = response.id
        this.dispatch.title = response.title
        this.dispatch.text = response.text
        this.dispatch.administrativeUnits = response.administrative_units;

      }

    },
    data() {
      return {
        dispatch: {
          title: '',
          administrativeUnits: [],
          text: ''
        },
        loading: false,
        administrativeUnitsAvailable: [],
        editorOptions: TINYMCE_OPTIONS(),
        text: '',
        isEmpty,
      };
    },
    methods: {
      onSaveEditButton({title, administrativeUnits}) {
        this.dispatch.title = title;
        this.dispatch.administrativeUnits = administrativeUnits;
      },
      administrativeUnitsInDispatch() {
        // if (isEmpty(this.dispatch)) return "Carregando..."
        if (this.dispatch.administrativeUnits.length === 0) return "Nenhum setor informado"
        return join(map(this.dispatch.administrativeUnits, (item) => {
          return item.name
        }), ', ');
      },
    },
  };
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/settings/dispatches/DispatchForm.vue